import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import * as flowConfig from "flows/forecasting/config";
import { projectIsForecastingAnalysis } from "flows/forecasting/interfaces";

const ContextSummary = ({
  project,
  hideModelTag,
}: {
  project: Project;
  hideModelTag?: boolean;
}) => {
  if (!projectIsForecastingAnalysis(project)) {
    return null;
  }

  const wsId = project.workspaces[0]?.workspace;

  return (
    <div className="m-1">
      <p>
        Target Variable:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.TARGET_VAR_KEY]}
        </span>
      </p>
      <p>
        Time Variable:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.TIMESTAMP_VAR_KEY]}
        </span>
      </p>
      <p>
        Grouping Variables:{" "}
        <span className="underline">
          {(project.meta_data[flowConfig.GROUPING_VARS_KEY] || []).length >= 1
            ? project.meta_data[flowConfig.GROUPING_VARS_KEY].join(", ")
            : "None"}
        </span>
      </p>
      {wsId && !hideModelTag && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
